export const propertyNavRoutes = Object.freeze({
  editProperty: 'edit',
  editRooms: 'edit-rooms',
  images: 'images',
  tourOperators: 'tour-operators',
  distribution: 'sales-channels',
  ocl: 'open-content-link',
  compare: 'compare-hotels',
  dashboard: 'dashboard',
  channelList: 'channel-list',
})

export const isNavigationAllowed = (propertyNavRouteId, permissions) => {
  if (!permissions) {
    return false
  }
  switch (propertyNavRouteId) {
    case propertyNavRoutes.dashboard:
      return permissions.dashboard.scores === true
    case propertyNavRoutes.channelList:
    case propertyNavRoutes.images:
    case propertyNavRoutes.editRooms:
      return true
    case propertyNavRoutes.editProperty:
    case propertyNavRoutes.ocl:
      return permissions.active === true
    case propertyNavRoutes.distribution:
      return permissions.dashboard.distribution === true
    case propertyNavRoutes.tourOperators:
      return permissions.dashboard.tourOperators === true
    case propertyNavRoutes.compare:
      return permissions.dashboard.tourOperators === true && permissions.dashboard.distribution === true
    default:
      return false
  }
}
